import { render, staticRenderFns } from "./BasicPreview.vue?vue&type=template&id=78e4234a&scoped=true"
import script from "./BasicPreview.vue?vue&type=script&lang=js"
export * from "./BasicPreview.vue?vue&type=script&lang=js"
import style0 from "./BasicPreview.vue?vue&type=style&index=0&id=78e4234a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e4234a",
  null
  
)

export default component.exports